import React, { useEffect, useState, useRef } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  TableComponents,
  FilterPod,
  ExportPodSpaceDg,
  TimeMessageDg,
  ReportOfflineTransactionActions,
  TimelineDg,
  ConfirmDialog as WargignSpaceSize,
} from 'components';
import createToast from 'components/Toast/Toast';
import { enifyDateTime } from 'utility';
import { useCopy } from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import { columns } from './Columns';
import generateData from './generateData';
import InitFilters from '../constants/InitFiltering';
import { useNavigate } from 'react-router-dom';
import ImprestServices from '../../services/ImprestServices';
import ShareSerives from 'utility/ShareServices';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';

const Content = ({ currencyText }) => {
  // -- STATES --//

  const navigate = useNavigate();

  //====================================================================================
  const [filters, setFilters] = useState(InitFilters());
  const [filterParams, setFilterParams] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);
  // -- HOOKS --//
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenTimetDG, setIsOpenTimetDG] = useState(false);
  const [timeRemain, setTimeRemain] = useState(0);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [isOpenTimeLineDg, setIsOpenTimeLineDg] = useState(false);
  const [timeLineLength, setTimeLineLength] = useState(0);
  const [isClickSearch, setIsClickSearch] = useState(false);
  const matches = useMediaQuery('(max-width:940px)');
  const [actionItems, setActionItems] = useState([
    {
      title: 'درخواست فایل خروجی با پسوند xls',
      type: 'Xls',
      status: 'offline',
    },
    {
      title: 'درخواست فایل خروجی با پسوند pdf',
      type: 'Pdf',
      status: 'offline',
    },
  ]);
  const classes = useStyle();
  const { copyItem } = useCopy();
  const tableRef = useRef();
  const actionsList = getDynamicObjectAction([
    'imprestFunderPage',
    'exportImprestFunderPage',
    'operationAllImprestFunderPage',
  ]);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const getFunder = async (ssoid) => {
    setLoadingPage(true);
    try {
      const result = await ImprestServices.getFunder({ offset: 0, size: 1, personId: ssoid });
      setLoadingPage(false);
      return result?.result[0];
    } catch (error) {
      setLoadingPage(false);
    }
  };
  const getList = async (query) => {
    const newFilters = [...filters];
    const filter = toFilterVOS([...newFilters]);
    if (!isClickSearch)
      return {
        data: [],
        page: query ? query?.pageNumber : page,
        totalCount: 0,
      };
    if (
      !filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00') ||
      !filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59')
    ) {
      createToast('خطا', 'لطفا فیلتر تاریخ را انتخاب نمایید.', 'danger');
      return {
        data: [],
        page: query ? query?.pageNumber : page,
        totalCount: 0,
      };
    }
    setLoadingPage(true);
    try {
      const orderBy = [];
      const params = {
        page: query ? query?.pageNumber : page,
        size: query ? query?.pageSize : size,
        accountId: null,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59')),
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };
      setFilterParams({ data, params });

      const res = await ImprestServices.getAllFunderImprest(data, params);
      reportOffileRequest();
      let list = [];
      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query ? query?.pageSize : page,
        });
      }

      setLoadingPage(false);
      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoadingPage(true);
      } else {
        setLoadingPage(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setIsClickSearch(true);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  /**
   * بعد از انتخاب نوع فایل ، جهت دریافت خروجی این تابع صدا زده خواهد شد
   */
  const onRequestFile = (type) => {
    if (type == 'Pdf') {
      const t = localStorage.getItem('funderImprestTime');
      if (t) {
        const date1 = new Date(t);
        const date2 = new Date();
        const diffTime = Math.abs(date2 - date1);
        const minuts = Math.ceil(diffTime / (1000 * 60)); // munits
        setTimeRemain(60 - minuts);
        if (minuts >= 60) {
          onExportPdfFile();
        } else {
          setIsOpenTimetDG(true);
          setIsLoadingExport(false);
        }
      } else {
        onExportPdfFile();
      }
    }
  };
  /**
   * دریافت خروجی pdf
   */
  const onExportPdfFile = () => {
    const p = {
      startDate: filterParams?.params?.startDate,
      endDate: filterParams?.params?.endDate,
    };
    ImprestServices.exportPdffunderImprestReport(filterParams?.data, p)
      .then((res) => {
        setIsOpenExportDG(true);
        reportOffileRequest();
        setIsLoadingExport(false);
      })
      .catch((error) => {
        setIsLoadingExport(false);
      });
  };

  const onExport = (data) => {
    onGetPodSpaceSize(data.type);
  };

  /**
   * گزارش آفلاین XLS
   */
  const onExportOffilneXLS = () => {
    const type = 'xls';
    const data = filterParams?.data;
    const p = {
      startDate: filterParams?.params?.startDate,
      endDate: filterParams?.params?.endDate,
      forceSave: false,
    };
    ImprestServices.reportFunderImprest(type, data, p)
      .then((res) => {
        setIsLoadingExport(false);
      })
      .catch((error) => {
        setIsLoadingExport(false);
      });
  };

  /**
   * سرویس حجم پاداسپیس کال میشود و براساس خروجی که برمیگردد در صورتی که hasCapacity ترو باشد یعنی حجم دارد و اگر فالز باشد یعنی حجم ندارد
   */
  const onGetPodSpaceSize = (type) => {
    setIsLoadingExport(true);
    if (type === 'Xls') {
      onExportOffilneXLS();
    } else {
      onRequestFile('Pdf');
    }
  };

  /**
   * کلیک بر روی دکمه لیست درخواست گزارشات در کامپوونت ReportOfflineTransactionActions
   */
  const onclickListReports = () => {
    navigate('/ReportOfflineTransactions?source=funderImprestReport');
  };

  const reportOffileRequest = () => {
    const obj = {
      reportStatusKeys: ['TO_DO', 'DOING'],
      reportKeys: ['ALL_FUNDER_IMPREST_XLS', 'ALL_FUNDER_IMPREST_PDF'],
    };
    ShareSerives.getRportOfflineRequest(obj)
      .then((res) => {
        setTimeLineLength(res?.count || 0);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (actionsList['imprestFunderPage']) {
      !isOpenTimeLineDg && reportOffileRequest();
    }
  }, [isOpenTimeLineDg]);
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box
            display={matches ? 'inline-grid' : 'flex'}
            justifyContent="end"
            alignItems="flex-end"
            style={{ marginBottom: 16, gap: matches ? '5px' : '0' }}
          >
            {actionsList['imprestFunderPage'] && (
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
            )}
            {actionsList['exportImprestFunderPage'] && (
              <ReportOfflineTransactionActions
                menuList={actionItems}
                onExport={onExport}
                loading={isLoadingExport}
                onclickListReports={onclickListReports}
                setIsOpenTimeLineDg={setIsOpenTimeLineDg}
                timeLineLength={timeLineLength}
              />
            )}
          </Box>
          {actionsList['imprestFunderPage'] && (
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          )}
        </Grid>
        {actionsList['imprestFunderPage'] && currencyText && (
          <Grid item xs={12}>
            <TableComponents
              data={getList}
              columns={columns(navigate, getFunder, actionsList, currencyText)}
              isLoading={loadingPage}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getList(ps);
              }}
            />
          </Grid>
        )}
      </Grid>
      <ExportPodSpaceDg isOpenExportDG={isOpenExportDG} setIsOpenExportDG={setIsOpenExportDG} />

      <TimeMessageDg
        isOpenTimetDG={isOpenTimetDG}
        setIsOpenTimetDG={setIsOpenTimetDG}
        timeRamain={timeRemain}
      />
      <TimelineDg
        isOpenTimetDG={isOpenTimeLineDg}
        setIsOpenTimetDG={setIsOpenTimeLineDg}
        reportKey={['ALL_FUNDER_IMPREST_XLS', 'ALL_FUNDER_IMPREST_PDF']}
      />
    </>
  );
};

const useStyle = makeStyles((theme) => ({
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));
export default Content;
